import { forwardRef } from "react";
import { MaskedInput, type MaskedInputProps } from "./MaskedInput";
import { formatCep } from "../../lib/format";

export type CepInputProps = Omit<MaskedInputProps, "mask">;

export const CepInput = forwardRef<HTMLInputElement, CepInputProps>(
  function CepInput(props, ref) {
    return (
      <MaskedInput
        ref={ref}
        inputMode="numeric"
        autoComplete="postal-code"
        placeholder="00000-000"
        mask={formatCep}
        {...props}
      />
    );
  }
);
